import request from '../utils/request'

export function createSmsTemplateApi(data){
  return request({
    url: '/admin/smsTemplate/smsTemplate.create',
    method: 'POST',
    data
  })
}

export function getSmsTemplateApi(params){
  return request({
    url: '/admin/smsTemplate/smsTemplate.getList',
    method: 'GET',
    params
  })
}

export function updateSmsTemplateApi(data){
  return request({
    url: '/admin/smsTemplate/smsTemplate.update',
    method: 'POST',
    data
  })
}

export function deleteSmsTemplateApi(data){
  return request({
    url: '/admin/smsTemplate/smsTemplate.delete',
    method: 'POST',
    data
  })
}

export function getJiaMengShangListApi(params){
  return request({
    url: '/admin/smsRecord/company.getList',
    method: 'GET',
    params
  })
}

export function chongZhiApi(data){
  return request({
    url: '/admin/smsRecord/smsRecord.give',
    method: 'POST',
    data
  })
}

export function getRecordListApi(params){
  return request({
    url: '/admin/smsRecord/smsRecord.getList',
    method: 'GET',
    params
  })
}